
import $ from 'jquery';

export function showWishlistButton() {

    const isSignedIn = ( $(".is_signed_in").html() ) != undefined;

    // Show wishlist in quickview.
    if ( isSignedIn ) {
        $("#wishlistbuttonspan").css('visibility', 'visible');
    }
};

$( document ).ready( function() {
    $( document ).on( 'finished_change_variant', showWishlistButton );
});